"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.removePlaceholders = removePlaceholders;
var _paper = _interopRequireDefault(require("paper"));
var _DOM = require("../../../Utils/DOM");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var HTML2Paper = exports["default"] = /*#__PURE__*/function () {
  function HTML2Paper() {
    _classCallCheck(this, HTML2Paper);
    _defineProperty(this, "position", {
      x: 0,
      y: 0
    });
    _defineProperty(this, "lineGroup", false);
    _defineProperty(this, "previousLineGroup", false);
  }
  _createClass(HTML2Paper, [{
    key: "createLineGroup",
    value: function createLineGroup(parentItem) {
      this.finishLine();
      var group = new _paper["default"].Group({
        applyMatrix: false
      });
      parentItem.addChild(group);
      this.lineGroup = group;
      return group;
    }
  }, {
    key: "finishImport",
    value: function finishImport() {
      this.finishLine();
    }
  }, {
    key: "finishLine",
    value: function finishLine() {
      var lineGroup = this.lineGroup,
        position = this.position,
        previousLineGroup = this.previousLineGroup;
      if (lineGroup) {
        var height = lineGroup.bounds.height;
        if (height === 0 && previousLineGroup) {
          position.y += previousLineGroup.bounds.height;
          lineGroup.remove();
        } else {
          this.previousLineGroup = lineGroup;
          lineGroup.position.y = position.y + lineGroup.bounds.height / 2;
          position.y = lineGroup.bounds.bottomLeft.y;
        }
      }
      position.x = 0;
    }
  }, {
    key: "importHTMLRecursive",
    value: function importHTMLRecursive(el, parentItem) {
      var _this = this;
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var position = this.position;
      var postProcess = [];
      var _iterator = _createForOfIteratorHelper(el.childNodes),
        _step;
      try {
        var _loop = function _loop() {
          var node = _step.value;
          if (node.nodeType === Node.TEXT_NODE) {
            var text = new _paper["default"].PointText(_objectSpread({
              content: node.nodeValue
            }, props));
            _this.lineGroup.addChild(text);
            text.position.x = position.x + text.bounds.width / 2;
            text.position.y = text.bounds.height / 2;
            position.x = text.bounds.bottomRight.x;
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            switch (node.nodeName) {
              case 'BR':
                {
                  // skip BR since it is wrapped in a DIV which already sets the position
                  break;
                }
              case 'SPAN':
                {
                  var addProps = _this.collectFontStyleProps(node);

                  // call the recursion to add children
                  _this.importHTMLRecursive(node, parentItem, _objectSpread(_objectSpread({}, props), addProps));
                  break;
                }
              case 'DIV':
              case 'P':
                {
                  _this.createLineGroup(parentItem);
                  var group = _this.lineGroup;
                  var _addProps = _this.collectFontStyleProps(node);

                  // call the recursion to add children
                  _this.importHTMLRecursive(node, parentItem, _objectSpread(_objectSpread({}, props), _addProps));
                  postProcess.push(function () {
                    var containerBounds = parentItem.internalBounds;
                    switch (props.textAlign) {
                      case 'center':
                        group.position.x = containerBounds.width / 2;
                        break;
                      case 'right':
                        group.position.x = containerBounds.width - group.bounds.width / 2;
                        break;
                      case 'left':
                      default:
                        group.position.x = group.bounds.width / 2;
                        break;
                    }
                  });
                  break;
                }
              default:
                {
                  // skip tag from processing
                }
            }
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      for (var _i = 0, _postProcess = postProcess; _i < _postProcess.length; _i++) {
        var process = _postProcess[_i];
        process();
      }
    }
  }, {
    key: "collectFontStyleProps",
    value: function collectFontStyleProps(node) {
      var styleProps = {};
      var _node$style = node.style,
        color = _node$style.color,
        fontStyle = _node$style.fontStyle,
        fontWeight = _node$style.fontWeight,
        fontSize = _node$style.fontSize,
        fontFamily = _node$style.fontFamily;
      if (color) {
        styleProps.fillColor = color;
      }
      if (fontWeight || fontStyle) {
        styleProps.fontWeight = [fontStyle, fontWeight].filter(function (i) {
          return !!i;
        }).join(' ');
      }
      if (fontSize) {
        // ignore fontSize for now, since it's global for the text object
        // styleProps.fontSize = fontSize;
      }
      if (fontFamily) {
        styleProps.fontFamily = fontFamily;
      }
      return styleProps;
    }
  }, {
    key: "importHTML",
    value: function importHTML(strOrDomElement) {
      var targetGroup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var keepContent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var addBaseRect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var initialProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var domElement;
      if ((0, _DOM.isElement)(strOrDomElement)) {
        domElement = strOrDomElement;
      } else if (typeof strOrDomElement === 'string') {
        domElement = document.createElement('div');
        domElement.innerHTML = strOrDomElement;
      } else {
        throw new Error("\n        HTML2Paper: wrong input type: ".concat(_typeof(strOrDomElement), ". \n        It should be an instance of HTMLElement or string.\n      "));
      }
      domElement = prepareInitialStyling(domElement, initialProps);
      if (targetGroup && !keepContent) {
        targetGroup.removeChildren();
      }
      var root = targetGroup;
      if (!root) {
        root = new _paper["default"].Group({
          applyMatrix: false
        });
      }
      var textGroup = new _paper["default"].Group({
        applyMatrix: false
      });
      this.createLineGroup(textGroup);
      this.importHTMLRecursive(domElement, textGroup, initialProps);
      this.finishImport();
      if (addBaseRect) {
        var rect = new _paper["default"].Path.Rectangle(textGroup.bounds);
        rect.data = {
          placeholder: true
        };
        root.addChild(rect);
      }
      root.addChild(textGroup);

      // the selection is not visualized after the group content has changed
      // so it has to be reapplied programmatically
      root.setSelected(root.isSelected());
      return root;
    }
  }]);
  return HTML2Paper;
}();
/**
 *
 * @param {HTMLElement} domElement
 * @param {object} initialProps
 */
function prepareInitialStyling(domElement, initialProps) {
  var node = domElement.cloneNode(true);
  var fontSize = initialProps.fontSize;
  if (node && node.firstChild && fontSize) {
    node.firstChild.style.fontSize = "".concat(fontSize, "px");
  }
  return node;
}
function removePlaceholders(xmlDoc) {
  // remove placeholders
  (0, _DOM.traverse)(xmlDoc, function (node) {
    try {
      var data = node.dataset && node.dataset.paperData && JSON.parse(node.dataset.paperData);
      if (data && data.placeholder) {
        node.parentNode.removeChild(node);
      }
    } catch (e) {
      // no handling needed
    }
  });
}